import { useMemo, useState } from 'react';
import { Box, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Page from '../components/Page';
import {
  AnnotateView,
  ClassesTagsView,
  DatasetView,
  ModelsView,
  TrainView,
  UploadDataView,
  VersionsView,
  WorkspaceLayout,
} from '../sections/trainModels';

export default function Test() {
  const theme = useTheme();
  const [activeScreen, setActiveScreen] = useState('train');
  const [isClassesDialogOpen, setIsClassesDialogOpen] = useState(false);
  const [isAnnotateEditorOpen, setIsAnnotateEditorOpen] = useState(false);

  const uploadView = UploadDataView({ theme });
  const annotateView = AnnotateView({
    isEditorOpen: isAnnotateEditorOpen,
    onOpenEditor: () => setIsAnnotateEditorOpen(true),
    onCloseEditor: () => setIsAnnotateEditorOpen(false),
  });
  const datasetView = DatasetView();
  const versionsView = VersionsView();
  const classesView = ClassesTagsView({
    isAddDialogOpen: isClassesDialogOpen,
    onOpenAddDialog: () => setIsClassesDialogOpen(true),
    onCloseAddDialog: () => setIsClassesDialogOpen(false),
  });
  const trainView = TrainView();
  const modelsView = ModelsView();

  const currentView = useMemo(() => {
    if (activeScreen === 'upload') return uploadView;
    if (activeScreen === 'annotate') return annotateView;
    if (activeScreen === 'dataset') return datasetView;
    if (activeScreen === 'versions') return versionsView;
    if (activeScreen === 'classes') return classesView;
    if (activeScreen === 'train') return trainView;
    if (activeScreen === 'models') return modelsView;

    return {
      main: <Box sx={{ p: 4, border: '1px dashed', borderColor: 'divider', borderRadius: 3 }}>Coming soon</Box>,
      side: null,
    };
  }, [activeScreen, annotateView, classesView, datasetView, modelsView, trainView, uploadView, versionsView]);

  return (
    <Page title="Train Models">
      <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default', py: 3 }}>
        <Container maxWidth="xxl">
          <WorkspaceLayout
            activeScreen={activeScreen}
            mainContent={currentView.main}
            sideContent={currentView.side}
            onSelectScreen={setActiveScreen}
          />
        </Container>
      </Box>
    </Page>
  );
}
